/**
 * Web Style Import
 *
 */

import './style/dnb-toggle-button.scss'
